import { useLocation, useNavigate } from "react-router-dom";
import { ProjectTwoTone, AlertTwoTone, ContactsTwoTone } from '@ant-design/icons';
import ViewStateService from "../../../../../services/view-state/ViewStateService";
import { MainSideBarWrapper, MenuIcon, MenuItemText, MenuItemWrapper, MenuWrapper } from "./MainSideBar.styled";
import { useEffect } from "react";

interface MainSideBarProps {

}

const MainSideBar: React.FC<MainSideBarProps> = (props)=> {
    // api
    let location = useLocation();
    let navigate = useNavigate();

    // menu metas
    let menuItems = [
        {
            name: '设备',
            path: '/device-management',
            icon: 'ProjectOutlined',
            title: '设备列表'
        },
        {
            name: '告警',
            path: '/alarm-events',
            icon: 'AlertOutlined',
            title: '告警列表'
        },
        {
            name: '我的',
            path: '/user-management',
            icon: 'UserOutlined',
            title: '我的'
        },
    ];

    // functions
    let onMenuItemClick = (menuItem: any)=> {
        navigate(menuItem.path);
        ViewStateService.getInstance().setStatusBarTitle(menuItem.title);
    }

    let isSelected = (menuItem: any)=> {
        let pathname = location.pathname;
        if (pathname.startsWith(menuItem.path)) {
            return true;
        }
        if (pathname === '/' || pathname === '/index.html') {
            if(menuItem.path === '/device-management') {
                return true;
            }
        }
        return false;
    }

    const iconMap = {
    ProjectOutlined: <ProjectTwoTone  style={{ transform: "rotate(270deg)" }}  twoToneColor={['#a09e9e', '#e4e2e2']}/>,
    AlertOutlined: <AlertTwoTone  twoToneColor={['#a09e9e', '#e4e2e2']}/>,
    UserOutlined: <ContactsTwoTone  twoToneColor={['#a09e9e', '#e4e2e2']} />,
    };

    const iconMapActive = {
    ProjectOutlined: <ProjectTwoTone  style={{ transform: "rotate(270deg)" }}  twoToneColor={undefined}/>,
    AlertOutlined: <AlertTwoTone  twoToneColor={undefined}/>,
    UserOutlined: <ContactsTwoTone  twoToneColor={undefined} />,
    };

    useEffect(()=> {
        for(let menuItem of menuItems) {
            if (isSelected(menuItem)) {
                ViewStateService.getInstance().setStatusBarTitle(menuItem.title);
                break;
            }
        }
    }, [location.pathname]);

    return (
        <MainSideBarWrapper>
            <MenuWrapper>
                {
                    menuItems.map((menuItem)=> {
                        return (
                            <MenuItemWrapper key={menuItem.path}  onClick={()=> onMenuItemClick(menuItem)}>
                                <MenuIcon> {isSelected(menuItem) ? iconMapActive[menuItem.icon] :iconMap[menuItem.icon]} </MenuIcon>
                                <MenuItemText className={isSelected(menuItem) ? "active": ""} >{menuItem.name}</MenuItemText>
                            </MenuItemWrapper>
                        )
                    })
                }
            </MenuWrapper>
        </MainSideBarWrapper>
    )
}

export default MainSideBar;

